import * as i0 from '@angular/core';
import * as i1 from './app.module';
import * as i2 from 'angular2-toaster/src/toaster-container.component';
import * as i3 from 'angular2-toaster/src/toast.component';
import * as i4 from '@angular/common';
import * as i5 from '@angular/forms';
import * as i6 from '@angular/router';
import * as i7 from './components/menu/menu.component';
import * as i8 from './components/footer/footer.component';
import * as i9 from './app.component';
import * as i10 from './pipes/translation.pipe';
import * as i11 from './core/core.module';
import * as i12 from './shared/shared.module';
import * as i13 from './app-routing.module';
import * as i14 from './components/menu/menu.module';
import * as i15 from './components/footer/footer.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = (null as any);
var _decl0_0:i2.ToasterContainerComponent = (<any>(null as any));
var _decl0_1:i3.ToastComponent = (<any>(null as any));
var _decl0_2:i4.NgClass = (<any>(null as any));
var _decl0_3:i4.NgComponentOutlet = (<any>(null as any));
var _decl0_4:i4.NgForOf<any> = (<any>(null as any));
var _decl0_5:i4.NgIf = (<any>(null as any));
var _decl0_6:i4.NgTemplateOutlet = (<any>(null as any));
var _decl0_7:i4.NgStyle = (<any>(null as any));
var _decl0_8:i4.NgSwitch = (<any>(null as any));
var _decl0_9:i4.NgSwitchCase = (<any>(null as any));
var _decl0_10:i4.NgSwitchDefault = (<any>(null as any));
var _decl0_11:i4.NgPlural = (<any>(null as any));
var _decl0_12:i4.NgPluralCase = (<any>(null as any));
var _decl0_13:i5.ɵbf = (<any>(null as any));
var _decl0_14:i5.NgSelectOption = (<any>(null as any));
var _decl0_15:i5.ɵq = (<any>(null as any));
var _decl0_16:i5.DefaultValueAccessor = (<any>(null as any));
var _decl0_17:i5.ɵbc = (<any>(null as any));
var _decl0_18:i5.ɵbe = (<any>(null as any));
var _decl0_19:i5.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_20:i5.SelectControlValueAccessor = (<any>(null as any));
var _decl0_21:i5.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_22:i5.RadioControlValueAccessor = (<any>(null as any));
var _decl0_23:i5.NgControlStatus = (<any>(null as any));
var _decl0_24:i5.NgControlStatusGroup = (<any>(null as any));
var _decl0_25:i5.RequiredValidator = (<any>(null as any));
var _decl0_26:i5.MinLengthValidator = (<any>(null as any));
var _decl0_27:i5.MaxLengthValidator = (<any>(null as any));
var _decl0_28:i5.PatternValidator = (<any>(null as any));
var _decl0_29:i5.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_30:i5.EmailValidator = (<any>(null as any));
var _decl0_31:i5.NgModel = (<any>(null as any));
var _decl0_32:i5.NgModelGroup = (<any>(null as any));
var _decl0_33:i5.NgForm = (<any>(null as any));
var _decl0_34:i6.RouterOutlet = (<any>(null as any));
var _decl0_35:i6.RouterLink = (<any>(null as any));
var _decl0_36:i6.RouterLinkWithHref = (<any>(null as any));
var _decl0_37:i6.RouterLinkActive = (<any>(null as any));
var _decl0_38:i7.MenuComponent = (<any>(null as any));
var _decl0_39:i8.FooterComponent = (<any>(null as any));
var _decl0_40:i9.AppComponent = (<any>(null as any));
var _decl0_41:i4.AsyncPipe = (<any>(null as any));
var _decl0_42:i4.UpperCasePipe = (<any>(null as any));
var _decl0_43:i4.LowerCasePipe = (<any>(null as any));
var _decl0_44:i4.JsonPipe = (<any>(null as any));
var _decl0_45:i4.SlicePipe = (<any>(null as any));
var _decl0_46:i4.DecimalPipe = (<any>(null as any));
var _decl0_47:i4.PercentPipe = (<any>(null as any));
var _decl0_48:i4.TitleCasePipe = (<any>(null as any));
var _decl0_49:i4.CurrencyPipe = (<any>(null as any));
var _decl0_50:i4.DatePipe = (<any>(null as any));
var _decl0_51:i4.I18nPluralPipe = (<any>(null as any));
var _decl0_52:i4.I18nSelectPipe = (<any>(null as any));
var _decl0_53:i10.TranslationPipe = (<any>(null as any));
var _decl0_54:i11.CoreModule = (<any>(null as any));
var _decl0_55:i12.SharedModule = (<any>(null as any));
var _decl0_56:i13.AppRoutingModule = (<any>(null as any));
var _decl0_57:i14.MenuModule = (<any>(null as any));
var _decl0_58:i15.FooterModule = (<any>(null as any));
var _decl0_59:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_60:i0.ElementRef = (<any>(null as any));
function _View_AppComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AppComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_40.isLoggedIn();
  currVal_0;
  const currVal_1:any = _decl0_40.isLoggedIn();
  currVal_1;
  const currVal_2:any = _decl0_40.loading;
  currVal_2;
  const currVal_3:any = _decl0_40.toasterConfig;
  currVal_3;
}



// WEBPACK FOOTER //
// ./src/app/app.module.ngfactory.ts